import typeToReducer from 'type-to-reducer';

import * as actions from "../actions";

const iniState = {
  creatingApplication: false,
  createdApplication: false,
  applicationID: null,
  licenceType: null,
  applicationNo: null,
  applicationFulfilled: false,
  storingAppPayment: false,
  applicationFinished: false,
  receivingApplication: false,
  receivedApplication: false,
  error: false
}

export const application = typeToReducer({
  [actions.STORE_APPLICATION_PAYMENT]: {
    PENDING: (state) => ({
      ...state,
      storingAppPayment: true,
      applicationFinished: false,
    }),
    REJECTED: (state) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
    }),
    FULFILLED: (state) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: true,
    }),
  },
  [actions.MAKE_CPP_PAYMENT]: {
    PENDING: (state) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
      applicationFulfilled: false,
    }),
    REJECTED: (state, action) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
      applicationFulfilled: action.payload && action.payload.response && action.payload.response.data &&
        action.payload.response.data.error && action.payload.response.data.error === 'PaymentAlreadyCompletedException',
    }),
    FULFILLED: (state) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
      applicationFulfilled: true,
    }),
  },
  [actions.CREATE_APPLICATION]: {
    PENDING: () => ({
      ...iniState,
      storingAppPayment: false,
      applicationFinished: false,
      creatingApplication: true,
      createdApplication: false,
      savingApplication: false,
      savedApplication: false,
      error: false
    }),
    REJECTED: (state) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
      creatingApplication: false,
      createdApplication: false,
      savingApplication: false,
      savedApplication: false,
      error: true
    }),
    FULFILLED: (state, action) => ({
      ...state,
      storingAppPayment: false,
      applicationFinished: false,
      creatingApplication: false,
      createdApplication: true,
      savingApplication: false,
      savedApplication: false,
      error: false,
      ...action.payload.data
    })
  },
  [actions.SAVE_APPLICATION]: {
    PENDING: (state) => ({
      ...state,
      savingApplication: true,
      savedApplication: false,
      error: false
    }),
    REJECTED: (state) => ({
      ...state,
      savingApplication: false,
      savedApplication: false,
      error: true
    }),
    FULFILLED: (state, action) => ({
      ...state,
      savingApplication: false,
      savedApplication: true,
      error: false
    })
  },
  [actions.GET_APPLICATION]: {
    PENDING: () => ({
      ...iniState,
      receivingApplication: true,
      receivedApplication: false,
      error: false
    }),
    REJECTED: (state) => ({
      ...state,
      receivingApplication: false,
      receivedApplication: false,
      error: true
    }),
    FULFILLED: (state, action) => ({
      ...state,
      receivingApplication: false,
      receivedApplication: true,
      error: false,
      ...action.payload.application
    })
  },
  [actions.CLEAR_FORM]: () => ({
    ...iniState
  })
}, iniState);
